import { ReactText } from 'react';
import { toast } from 'react-toastify';
import { StyledCheckCircle, StyledInfoCircle, StyledXCircle } from './style';
import TextContainer, { TextContainerI } from './notifyTextContainer';

interface PropsI extends TextContainerI {
  type: string;
  customIcon?: JSX.Element;
}

const showNotification = ({
  text,
  type,
  customIcon,
  callback,
}: PropsI): ReactText => {
  switch (type) {
    case 'success':
      return toast.success(<TextContainer text={text} callback={callback} />, {
        icon: customIcon || <StyledCheckCircle />,
      });
    case 'error':
      return toast.error(<TextContainer text={text} callback={callback} />, {
        icon: customIcon || <StyledXCircle />,
      });
    default:
      return toast(<TextContainer text={text} callback={callback} />, {
        icon: customIcon || <StyledInfoCircle />,
      });
  }
};

export default showNotification;
